import React from 'react';

import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Tag } from 'primereact/tag';

import { ActualOperation, Employee } from '../../types/interfaces';

const COLUMN_WIDTHS = {
  changed: '17px',
  id: '90px',
  operation: '150px',
  attainment: '120px',
  volume: '90px',
  measure: '100px',
  employees: '180px',
  ktu: '56px',
  comment: '120px',
  edit: '56px',
  delete: '56px'
} as const;

interface NestedActualOperationsProps {
  operation: ActualOperation;
}

const NestedActualOperations: React.FC<NestedActualOperationsProps> = ({
  operation
}) => {
  const actualOperationBodyTemplate = () => {
    return <div>{operation.operation.label}</div>;
  };

  const executorBodyTemplate = (executor: Employee) => {
    return <Tag value={executor.fullName}></Tag>;
  };

  const ktuBodyTemplate = (executor: Employee) => {
    if (operation.changed) {
      return '—';
    }
    return executor.laborAccountingCoefficient || '—';
  };

  const expandedRows = operation.employees;

  return (
    <div className="nested-table-container">
      <DataTable 
        value={expandedRows} 
        scrollable
        pt={{
          wrapper: {
            style: { 
              tableLayout: 'fixed'
            }
          },
          table: {
            style: {
              width: '100%',
              minWidth: '1200px'
            }
          }
        }}
      >
        <Column
          style={{ 
            width: COLUMN_WIDTHS.changed,
            minWidth: COLUMN_WIDTHS.changed,
            maxWidth: COLUMN_WIDTHS.changed
          }}
        />
        <Column
          style={{ 
            width: COLUMN_WIDTHS.id,
            minWidth: COLUMN_WIDTHS.id,
            maxWidth: COLUMN_WIDTHS.id
          }}
        />
        <Column
          body={actualOperationBodyTemplate}
          style={{ 
            width: COLUMN_WIDTHS.operation,
            minWidth: COLUMN_WIDTHS.operation,
            maxWidth: COLUMN_WIDTHS.operation
          }}
        />
        <Column
          style={{ 
            width: COLUMN_WIDTHS.attainment,
            minWidth: COLUMN_WIDTHS.attainment,
            maxWidth: COLUMN_WIDTHS.attainment
          }}
        />
        <Column
          style={{ 
            width: COLUMN_WIDTHS.volume,
            minWidth: COLUMN_WIDTHS.volume,
            maxWidth: COLUMN_WIDTHS.volume
          }}
        />
        <Column
          style={{ 
            width: COLUMN_WIDTHS.measure,
            minWidth: COLUMN_WIDTHS.measure,
            maxWidth: COLUMN_WIDTHS.measure
          }}
        />
        <Column
          style={{ 
            width: COLUMN_WIDTHS.measure,
            minWidth: COLUMN_WIDTHS.measure,
            maxWidth: COLUMN_WIDTHS.measure
          }}
        />
        <Column
          field="fullName"
          body={executorBodyTemplate}
          style={{ 
            width: COLUMN_WIDTHS.employees,
            minWidth: COLUMN_WIDTHS.employees,
            maxWidth: COLUMN_WIDTHS.employees
          }}
        />
        <Column
          field="laborAccountingCoefficient"
          body={ktuBodyTemplate}
          style={{ 
            width: COLUMN_WIDTHS.ktu,
            minWidth: COLUMN_WIDTHS.ktu,
            maxWidth: COLUMN_WIDTHS.ktu
          }}
          alignHeader="center"
        />
        <Column
          style={{ 
            width: COLUMN_WIDTHS.comment,
            minWidth: COLUMN_WIDTHS.comment,
            maxWidth: COLUMN_WIDTHS.comment
          }}
        />
        <Column
          style={{ 
            width: COLUMN_WIDTHS.edit,
            minWidth: COLUMN_WIDTHS.edit,
            maxWidth: COLUMN_WIDTHS.edit
          }}
        />
        
        <Column
          style={{ 
            width: COLUMN_WIDTHS.delete,
            minWidth: COLUMN_WIDTHS.delete,
            maxWidth: COLUMN_WIDTHS.delete
          }}
        />
      </DataTable>
    </div>
  );
};

export default NestedActualOperations;
